const encodeBase64Url = (value) =>
  btoa(value).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const decodeBase64Url = (value) => {
  const padded = value + "=".repeat((4 - (value.length % 4)) % 4);
  return atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
};

export const encodeEntityId = (id) => {
  if (!id) {
    return "";
  }

  return encodeBase64Url(JSON.stringify({ i: String(id), v: 1 }));
};

export const decodeEntityId = (slug) => {
  if (!slug) {
    return null;
  }

  if (/^\d{12}$/.test(slug)) {
    return slug;
  }

  try {
    const parsed = JSON.parse(decodeBase64Url(slug));
    return parsed?.i || slug;
  } catch {
    return slug;
  }
};

export const buildBlogPath = (id) =>
  `/blogpage/${encodeURIComponent(encodeEntityId(id))}`;

export const buildCaseStudyPath = (id) =>
  `/casestudy/${encodeURIComponent(encodeEntityId(id))}`;

export const pickRandomItems = (items, count = 3) => {
  if (!items?.length) {
    return [];
  }

  const shuffled = [...items].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, shuffled.length));
};
